export const CLONE_EVENT = 'CLONE_EVENT'
export const CLEAR_CLONE_DATA = 'CLEAR_CLONE_DATA'
